module.exports = "./img/4c8c71993d77291a5b11f6f79a4d026c.jpg";